module.exports = __webpack_public_path__ + "img/bg-0.b03b104c.webp";